import React, { Component } from "react";
import { Provider } from "react-redux";
import store from "./config/store";
import Routes from "./components/routes/Routes";
import WithInitialData from "./components/HOC/WithInitialData";
import "./App.css";

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <WithInitialData>{() => <Routes />}</WithInitialData>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js